<template>
  <div>
    <icon-view
      icon="fas fa-info-circle text-orange"
      icon-background="white"
      title="Información de Material o Equipo"
    />
    <div class="row mt-3">
      <div class="col-12 col-md">
        <label class="data-name">Título:</label>
        <div class="form-group">
          <input class="form-control" disabled :value="model.name ?? '-'" />
        </div>
      </div>
      <div class="col-12 col-md">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.saloon"
              :options="saloons"
              label="Tipo de Salón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
              :disabled="addingProcess"
            />
          </validation-provider>
        </div>
      </div>
      <div v-if="!model.id || addingProcess" class="col-12 col-md-4">
        <div class="form-group">
          <validation-provider
            mode="eager"
            v-slot="{ errors }"
            name="cantidad"
            :custom-messages="{
              required: 'Este campo es requerido.',
            }"
            rules="required|min_value:1"
          >
            <custom-input
              v-model="model.quantity"
              type="number"
              label="Cantidad:"
              :custom-error-msg.sync="errors[0]"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
    </div>
    <validation-provider v-slot="{ errors }" rules="required">
      <div class="text-gray font-14 my-1">
        Descripción:
      </div>
      <custom-text-area
        v-model="model.description"
        :count-classes="['d-block', 'small-counter', 'text-right']"
        custom-error-msg="Este campo es requerido"
        :error="errors[0]"
        :maxlength="3000"
        :disabled="addingProcess"
        placeholder="Describa las características del Material o Equipo"
        show-char-count
      />
    </validation-provider>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'ItemInfo',
  components: {
    IconView,
    CustomDropDown,
    CustomInput,
    CustomTextArea,
  },
  props: {
    saloons: {
      type: Array,
      require: true,
      default: () => [],
    },
    schools: {
      type: Array,
      require: true,
      default: () => [],
    },
    addingProcess: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      require: true,
      default: () => ({
        name: null,
        saloon: null,
        description: null,
      }),
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot > em {
  font-size: 16px !important;
}
</style>
